import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Package, Menu, X, Phone, Mail, MapPin, Shield, Truck, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import CookieBanner from "@/components/CookieBanner";

const navLinks = [
  { to: "/", label: "Accueil" },
  { to: "/commander", label: "Commander" },
  { to: "/suivi", label: "Suivre mon colis" },
];

/* Scroll reveal hook */
export function useScrollReveal() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach(e => { 
        if (e.isIntersecting) { 
          e.target.classList.add("visible"); 
          observer.unobserve(e.target); 
        } 
      }),
      { threshold: 0.1, rootMargin: "0px 0px -40px 0px" }
    );
    document.querySelectorAll(".reveal").forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);
}

function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [location]);

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 ${scrolled ? "bg-gofret-navy/95" : "bg-gofret-navy"}`}>
      {/* navbar */}
    </nav>
  );
}

function Footer() {
  return (
    <footer className="bg-gofret-navy text-white">
      {/* footer */}
    </footer>
  );
}

export default function Layout({ children }) {
  const location = useLocation();

  // ✅ GOOGLE TAG MANAGER
  useEffect(() => {
    const script = document.createElement("script");
    script.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id=GTM-NB66B2SW'+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-NB66B2SW');
    `;
    document.head.appendChild(script);
  }, []);

  return (
    <>
      {/* ✅ NOSCRIPT (important) */}
      <noscript>
        <iframe
          src="https://www.googletagmanager.com/ns.html?id=GTM-NB66B2SW"
          height="0"
          width="0"
          style={{ display: "none", visibility: "hidden" }}
        ></iframe>
      </noscript>

      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main key={location.pathname} className="flex-1 pt-16 page-enter">
          {children}
        </main>
        <Footer />
        <CookieBanner />
      </div>
    </>
  );
}
